import axios from 'axios'

// 网站公开内容接口（无需登录）。默认同源 /api（生产由 nginx 转发到后端），可用 VUE_APP_API_BASE 覆盖
const API_BASE = process.env.VUE_APP_API_BASE || '/api'

const client = axios.create({
  baseURL: API_BASE,
  timeout: 30000
})

client.interceptors.response.use(
  response => {
    const data = response.data
    if (data && data.code !== undefined && data.code !== 200) {
      return Promise.reject(new Error(data.message || 'Request failed'))
    }
    return data ? data.data : null
  },
  error => Promise.reject(error)
)

/** 首页/导航聚合：分类 + 精选产品 */
export function getOverview() {
  return client.get('/v1/site/content/overview')
}

/** 分类详情（含产品列表） */
export function getCategory(slug) {
  return client.get(`/v1/site/categories/${slug}`)
}

/** 产品详情 */
export function getProduct(slug) {
  return client.get(`/v1/site/products/${slug}`)
}

/** 实车案例列表 / 详情 */
export function getInstallations() {
  return client.get('/v1/site/installations')
}
export function getInstallation(slug) {
  return client.get(`/v1/site/installations/${slug}`)
}

/** 颜色列表 / 详情（含关联产品） */
export function getColors() {
  return client.get('/v1/site/colors')
}
export function getColor(slug) {
  return client.get(`/v1/site/colors/${slug}`)
}

/** 洞察与新闻列表 / 详情（含关联产品） */
export function getArticles(params) {
  return client.get('/v1/site/articles', { params })
}
export function getArticle(slug) {
  return client.get(`/v1/site/articles/${slug}`)
}

/** 关于页 */
export function getAbout() {
  return client.get('/v1/site/about')
}
